import { render } from "./MfTagInput.vue?vue&type=template&id=05d748a4&scoped=true"
import script from "./MfTagInput.vue?vue&type=script&lang=js"
export * from "./MfTagInput.vue?vue&type=script&lang=js"

import "./MfTagInput.vue?vue&type=style&index=0&id=05d748a4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05d748a4"]])

export default __exports__